export const UPLOAD_WEIGHT_DISPUTE_REQUEST = "UPLOAD_WEIGHT_DISPUTE_REQUEST";
export const UPLOAD_WEIGHT_DISPUTE_SUCCESS = "UPLOAD_WEIGHT_DISPUTE_SUCCESS";
export const UPLOAD_WEIGHT_DISPUTE_FAILURE = "UPLOAD_WEIGHT_DISPUTE_FAILURE";
export const uploadWeightDisputeSuccess = (payload) => ({
    type: UPLOAD_WEIGHT_DISPUTE_SUCCESS,
    payload,
});
export const uploadWeightDisputeRequest = (payload) => ({
    type: UPLOAD_WEIGHT_DISPUTE_REQUEST,
    payload,
});
export const uploadWeightDisputeFailure = (payload) => ({
    type: UPLOAD_WEIGHT_DISPUTE_FAILURE,
    payload,
});
